/** Штриховка гипсокартонного потолка проверенной диагональной сеткой. */
import { CEILING_HATCH_COLOR, CEILING_HATCH_STEP } from "./ceilingHatchGeometry";

interface Props {
	roomId: string;
	points: string;
	mmPerPx: number;
}

export const DrywallHatch = ({ roomId, points, mmPerPx }: Props) => {
	const patternId = `room-ceiling-${roomId}-drywall`;

	return (
		<>
			<defs>
				<pattern
					id={patternId}
					patternUnits="userSpaceOnUse"
					width={CEILING_HATCH_STEP}
					height={CEILING_HATCH_STEP}
					patternTransform="rotate(45)"
				>
					<line
						x1="0"
						y1="0"
						x2="0"
						y2={CEILING_HATCH_STEP}
						stroke={CEILING_HATCH_COLOR}
						strokeWidth={mmPerPx}
					/>
					<line
						x1="0"
						y1="0"
						x2={CEILING_HATCH_STEP}
						y2="0"
						stroke={CEILING_HATCH_COLOR}
						strokeWidth={mmPerPx}
					/>
				</pattern>
			</defs>
			<polygon points={points} fill={`url(#${patternId})`} opacity="0.55" />
		</>
	);
};
